module.exports = "/img/_/_/_/assets/images/creeper/battle/common//2.jpg?8c8ca4385db24249436d1fc0c5e9094b";